import React, { useMemo, useState } from 'react';
import { isMobile } from '@pascal/pascal-core';

import Tabs from './tabs';
import TabItem from './tabsItem';
import TabsContent from './tabsContent';

const tabsWeb = [
  { name: 'ANY', id: 1 },
  { name: 'MORE', id: 2 },
];

const tabsMobile = [
  { name: 'ANY', id: 1 },
  { name: 'BLACK', id: 3 },
  { name: 'RED', id: 2 },
];

const defaultActiveTab = 1;

const GameTabs = ({ mobile = true, replayActiveMainMoreSection }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(defaultActiveTab);

  const handleTabChange = (value) => {
    setActiveTabIndex(value);
  };

  const tabs = useMemo(() => (isMobile() ? tabsMobile : tabsWeb), [isMobile()]);

  const activeTabContent = useMemo(() => {
    return (
      <div className='mob-game-events-inside'>
        <Tabs handleTabChange={handleTabChange} activeTab={activeTabIndex}>
          {tabs.map((item) => (
            <TabItem
              key={item.id}
              value={item.id}
              label={item.name}
              replayActiveMainMoreSection={replayActiveMainMoreSection}
            />
          ))}
        </Tabs>
        <TabsContent
          activeTabIndex={activeTabIndex}
          defaultActiveTab={defaultActiveTab}
          replayActiveMainMoreSection={replayActiveMainMoreSection}
        />
      </div>
    );
  }, [activeTabIndex, replayActiveMainMoreSection]);

  if (mobile) {
    return <div className='mob-game-events'>{activeTabContent}</div>;
  }

  return (
    <div className='content-center-left '>
      <div className='con-center-left-inside'>{activeTabContent}</div>
    </div>
  );
};

export default GameTabs;
